<template>
  <v-container fluid class="pa-10 text-left" v-if="story">
    <v-row>
      <h1>{{ $t("storyHub.publishing.wizard.reviewStoryInformation") }}</h1>
    </v-row>
    <v-row>
      <p>
        {{ $t("storyHub.publishing.wizard.whileThisInformationCanBeReviewed") }}
      </p>
    </v-row>
    <v-row>
      <v-col md="3">
        <v-card
          ><v-card-title
            >{{ $t("story.coverArt.coverArt") }}
            <WarningIcon v-if="story && !story.coverArt" /> </v-card-title
        ></v-card>
        <v-img
          class="mt-5 rounded-xl"
          v-if="story && story.coverArt"
          :src="story.coverArt.contentUrl"
          contain
        />
        <v-sheet
          min-height="300"
          color="background"
          class="mt-7 rounded-xl error--text"
          v-else
          align="center"
        >
          <v-row align="center" style="height: 300px">
            <v-col class="pa-10">{{
              $t("storyHub.publishing.errors.coverArtRequired")
            }}</v-col>
          </v-row>
        </v-sheet>
      </v-col>
      <v-col md="9">
        <v-row>
          <v-col>
            <v-card>
              <v-card-title
                >{{ $t("story.title") }}<WarningIcon v-if="!story.name" />
              </v-card-title>
              <v-card-text v-if="story.name"
                ><h1>{{ story.name }}</h1></v-card-text
              >
              <v-card-text class="error--text" v-else>{{
                $t("storyHub.publishing.errors.titleRequired")
              }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            ><v-card
              ><v-card-title>
                <v-icon class="material-icons">article</v-icon>
                {{ $t("story.tagline") }}<WarningIcon v-if="!story.summary"
              /></v-card-title>
              <v-card-text v-if="story.summary">{{
                story.summary
              }}</v-card-text>
              <v-card-text class="error--text" v-else>{{
                $t("storyHub.publishing.errors.taglineRequired")
              }}</v-card-text>
            </v-card></v-col
          >
        </v-row>
        <v-row>
          <v-col
            ><v-card>
              <v-card-title
                ><v-icon left>mdi-book-open-blank-variant</v-icon>
                {{ $t("story.genre") }}<WarningIcon v-if="!story.genre"
              /></v-card-title>
              <v-card-text v-if="story.genre">
                <v-chip
                  >{{ story.genre ? story.genre._id : "" }}
                </v-chip></v-card-text
              >
              <v-card-text class="error--text" v-else>{{
                $t("storyHub.publishing.errors.genreRequired")
              }}</v-card-text>
            </v-card>
          </v-col>
          <v-col
            ><v-card>
              <v-card-title
                ><v-icon left>mdi-account-multiple</v-icon>
                {{ $t("story.ageRating") }}<WarningIcon v-if="!story.ageRating"
              /></v-card-title>
              <v-card-text v-if="story.ageRating">
                <v-chip
                  >{{ story.ageRating ? story.ageRating._id : "" }}
                </v-chip></v-card-text
              >
              <v-card-text class="error--text" v-else>{{
                $t("storyHub.publishing.errors.ageRatingRequired")
              }}</v-card-text>
            </v-card>
          </v-col>
          <v-col
            ><v-card>
              <v-card-title
                ><v-icon left>mdi-clock-outline</v-icon>
                {{ $t("story.duration") }}<WarningIcon v-if="!story.duration"
              /></v-card-title>
              <v-card-text v-if="story.duration">
                <v-chip>{{ story.duration }} </v-chip></v-card-text
              >
              <v-card-text class="error--text" v-else>{{
                $t("storyHub.publishing.errors.storyDurationRequired")
              }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-card-title>
                <v-icon left>mdi-tag</v-icon>
                {{ $t("story.tags") }}</v-card-title
              >
              <v-card-text>
                <v-chip-group v-if="story.tags && story.tags.length > 0">
                  <v-chip v-for="tag in story.tags" :key="tag.id"
                    >#{{ tag._id }}</v-chip
                  >
                </v-chip-group>
                <div v-else>
                  {{ $t("storyHub.publishing.errors.noTagsApplied") }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row> </v-row>
  </v-container>
  <v-container v-else>
    <v-row>
      <v-col>Story not loaded yet </v-col>
    </v-row>
  </v-container>
</template>
<script>
import gql from "graphql-tag";
import iris from "@/iris";
import WarningIcon from "./WarningIcon.vue";
export default {
  components: {
    WarningIcon,
  },
  apollo: {
    story: {
      query: gql`
        query GetStory($id: ID!) {
          story(id: $id) {
            id
            name
            summary
            description
            duration
            coverArt {
              id
              contentUrl
            }
            owner {
              email
            }
            ageRating {
              _id
              id
            }
            genre {
              _id
              id
            }
            tags {
              _id
              id
            }
          }
        }
      `,
      watchLoading(isLoading) {
        this.loading = isLoading;
      },
      variables() {
        return {
          id: this.id,
        };
      },
      update(data) {
        return data.story;
      },
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    validate() {
      return this.$refs["basicInfoOverviewForm"].validate();
    },
  },
  watch: {
    validStory(newValue) {
      this.$emit('validStory', newValue)
    }
  },
  computed: {
    id() {
      return `${iris.story}${this.$route.params.id}`;
    },
    validStory() {
      let validStory = true;

      if (!this.story) {
        return true;
      } else if (
        !this.story.coverArt ||
        !this.story.name ||
        !this.story.summary ||
        !this.story.genre ||
        !this.story.ageRating ||
        !this.story.duration
      ) {
        return false
      }

      return validStory;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-sheet.v-card {
  background-color: var(--v-background-base);
  border-radius: 10px;
  box-shadow: none;
}
.v-card__title {
  color: var(--v-secondaryAction-base);
  line-height: 1.5rem;
  font-size: 1.3rem;
}

.theme--light.v-chip:not(.v-chip--active) {
  background: var(--v-secondaryAction-base);
  color: white;
}
</style>